import React from 'react'
import { Link } from 'react-router-dom'
import { FcGoogle } from 'react-icons/fc'
import { HiOutlineMail } from 'react-icons/hi'
import { RiLockPasswordLine } from 'react-icons/ri'
import { LogInput } from '../../Interfaces/Interfaces';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { SignIn } from './../../actions/index';
import Swal from 'sweetalert2'
import RecuperarContrasena from './RecuperarContrasena'

const LoginForm = ():JSX.Element => {
  const [isVisible, setIsVisible] = React.useState(false);
  const [input, setInput] = useState<LogInput>({
    email: '',
    password:''
  });

  const dispatch = useDispatch();

  type HandleForm = (e: React.ChangeEvent<HTMLInputElement>) => void;

  const handleChange: HandleForm = (e) => {
    const { name, value } = e.target;
    setInput((prevInput: LogInput) => ({
      ...prevInput,
      [name]: value,
    }));

  };

  const handleRecuperarContraseña = () => {
    setIsVisible(true)
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
   await dispatch(SignIn(input));
   let token = localStorage.getItem("token") 
   
   if(token) {
   await Swal.fire({
      title: 'Has iniciado con exito',
      icon: 'success',
      timer: 1000,
      timerProgressBar: true,
      showConfirmButton: false
    })

    window.location.href = '/'
    

   } else {
    Swal.fire({
      title: 'Hubo un error en tu inicio de sesion, intentelo nuevamente',
      icon: 'error',
      timer: 1500,
      timerProgressBar: true,
      showConfirmButton: false
    })
   }
}


  return (
       <div className='flex flex-col items-center justify-center mt-4'>

        <h1 className='font-roboto text-[28px]'>INICIA SESION</h1>

         

       <div className='w-auto sm:w-screen flex justify-center items-center'>

        <div className='bg-white mt-12 w-full sm:w-1/3 shadow-2xl'>
            
             <form onSubmit={handleSubmit} className='flex flex-col mt-12 items-center p-8 justify-center w-full'>
               
              <div className="flex items-center w-full sm:w-2/3 mb-8">
               <HiOutlineMail size={30} className="text-gray-400" />
               <input onChange={handleChange} name='email' placeholder='Email' className='border w-full ml-2 p-2 h-14 rounded shadow-md' />
              </div>
 
              
              <div className="flex items-center w-full sm:w-2/3 mb-8">
              <RiLockPasswordLine size={30} className="text-gray-400" />
              <input onChange={handleChange} name='password' type="Password" placeholder='Contraseña' className='border ml-2 p-2 w-full h-14 rounded shadow-md' />
              </div>
        
          <div className='flex flex-col w-full sm:mt-4 mb-8 justify-center items-center'>
             
             <button type='submit' className='border w-2/5 h-10 flex flex-row items-center justify-center bg-background_home text-white mb-2 rounded shadow-md'>
               <p className='font-roboto'>Iniciar Sesion</p>
             </button>
             
             <Link to='/createaccount'>
                 <button className='text-md font-roboto text-blue-600'>No tenes cuenta? Crea una</button>
             </Link>
             <button type="button" onClick={handleRecuperarContraseña} className='text-sm font-roboto text-blue-600'>Olvidaste tu contraseña?</button>
            
            <RecuperarContrasena
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            />
         </div>
             </form>  

        </div>
              

       </div>
   
       </div> 
   
   
   
    // <div className='w-screen p-16 mt-4 flex items-center justify-center'>
    
    // <div style={{ height: 470 }} className='p-8 bg-white  sm:w-1/4 w-80 rounded-lg shadow-2xl space-y-12 flex items-center justify-center flex-col'>
    //    <form className='w-full flex flex-col justify-center items-center' onSubmit={handleSubmit}>
      
    //   <div className="flex items-center mb-4">
    //     <HiOutlineMail size={30} className="text-gray-400 mr-2" />
    //     <input onChange={handleChange} name='email' placeholder='Email' className='border w-full h-10 rounded pl-4 shadow-md' />
    //   </div>
      
    //   <div className="flex items-center mb-4">
    //   <RiLockPasswordLine size={30} className="text-gray-400 mr-2" />
    //   <input onChange={handleChange} name='password' type="password" placeholder='Password' className='border w-full h-10 rounded pl-4 shadow-md' />
    //   </div>

    //   <button type='submit' className='border w-1/2 h-10 flex flex-row items-center justify-center space-x-3 rounded shadow-md'>
    //      <FcGoogle />
    //      <p>Login</p>
    //   </button>
     
    //   <div className='flex flex-col justify-center items-center space-y-4'>
    //     <Link to='/createaccount'>
    //         <button className='text-md text-blue-600'>Crea tu cuenta</button>
    //     </Link>
    //   <button className='text-sm text-blue-600'>Olvidaste tu contraseña?</button>
    //   </div>

    //   </form>

    //   </div>

    // </div>
  )
}

export default LoginForm